<template>

  <header class="plex-regular flex flex-col items-center justify-center bg-cover bg-center md:bg-left-top bg-no-repeat"
    :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">

    <div class="flex flex-col items-center mt-2 md:mt-12 w-full">

      <img class="object-contain w-11/12 md:w-10/12 lg:w-6/12 py-6 md:py-0" src="@/assets/logo.png" />

      <div class="flex flex-col md:flex-row gap-2 md:gap-4 mt-5 w-full px-4 text-center md:w-auto">
        <router-link to="/"
          class="px-5 py-2 border border-[#57af4e] bg-[#57af4e] text-white font-semibold hover:bg-white hover:text-[#57af4e] rounded-2xl">
          <i class="pi pi-user mr-2"></i>VISITANTE
        </router-link>
        <router-link to="/instituciones"
          class="px-5 py-2 border border-[#57af4e] bg-[#57af4e] text-white font-semibold hover:bg-white hover:text-[#57af4e] rounded-2xl">
          <i class="pi pi-globe mr-2"></i>INSTITUCIONES
        </router-link>
        <!-- <router-link to="/expositores"
          class="px-5 py-2 border border-[#57af4e] bg-[#57af4e] text-white font-semibold hover:bg-white hover:text-[#57af4e] rounded-2xl">
          <i class="pi pi-credit-card mr-2"></i>EXPOSITOR
        </router-link>
        -->
        <router-link to="/credenciales"
          class="px-5 py-2 border border-[#57af4e] bg-[#57af4e] text-white font-semibold hover:bg-white hover:text-[#57af4e] rounded-2xl">
          <i class="pi pi-qrcode mr-2"></i>YA ME ACREDITÉ
        </router-link>


      </div>

      <img class="w-[60%] md:w-[30%] lg:w-[15%] object-contain py-4 " src="@/assets/organiza.png" />

    </div>
  </header>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueScrollTo from 'vue-scrollto';

export default defineComponent({
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    }

  },
});

</script>